// Central API helpers — single source for base URL + auth headers.
// Replaces the per-file `const API_URL = ...` / `authHeaders` boilerplate.

export const API_URL: string = import.meta.env.VITE_API_URL || 'http://localhost:3000'

const TOKEN_KEY = 'atlas_token'

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY)
}

// Auth headers for fetch calls. Pass extra headers via `extra`
// (e.g. { 'Content-Type': 'application/json' }). For FormData uploads,
// do NOT set Content-Type — the browser adds the multipart boundary.
export function getAuthHeaders(extra: Record<string, string> = {}): Record<string, string> {
  const headers: Record<string, string> = { ...extra }
  const token = getToken()
  if (token) headers['Authorization'] = `Bearer ${token}`
  return headers
}

// fetch() wrapper that prepends API_URL and injects the auth token.
// `path` may be a full URL (starts with http) or an API path (/api/...).
export function apiFetch(path: string, options: RequestInit = {}): Promise<Response> {
  const url = path.startsWith('http') ? path : `${API_URL}${path}`
  const headers = { ...getAuthHeaders(), ...(options.headers as Record<string, string> | undefined) }
  return fetch(url, { ...options, headers })
}

// apiFetch + JSON body + parsed response.
export async function apiJson<T = unknown>(path: string, options: RequestInit = {}): Promise<T> {
  const res = await apiFetch(path, {
    ...options,
    headers: { 'Content-Type': 'application/json', ...(options.headers as Record<string, string> | undefined) },
  })
  return res.json() as Promise<T>
}
